import {WhitelabelEventWithPayload} from "../../events/Events";
import {EventBus} from "../../events/EventBus";

export interface GetNumberOfListingRequestEventPayload {
    buttonId: string;
}

export class GetNumberOfListingRequestEvent implements WhitelabelEventWithPayload<GetNumberOfListingRequestEventPayload> {
    type: string;
    payload: GetNumberOfListingRequestEventPayload;
    static readonly TYPE: string = 'get-number-of-listing-request';

    constructor(payload: GetNumberOfListingRequestEventPayload) {
        this.type = GetNumberOfListingRequestEvent.TYPE;
        this.payload = payload;
    }
}

export interface ListingsFilteringResponseEventPayload {
    numberOfFilteredResults: string;
    buttonId: string;
}

export class ListingsFilteringResponseEvent implements WhitelabelEventWithPayload<ListingsFilteringResponseEventPayload> {
    type: string;
    payload: ListingsFilteringResponseEventPayload;
    static readonly TYPE: string = 'listing-filtering-response';

    constructor(payload: ListingsFilteringResponseEventPayload) {
        this.type = ListingsFilteringResponseEvent.TYPE;
        this.payload = payload;
    }
}

export interface FiltersParams {
    buttonId: string,
    geoId: string,
    roomsMin: string,
    roomsMax: string,
    bathRoomsMin: string,
    bathRoomsMax: string,
    priceMin: string,
    priceMax: string,
    areaMin: string,
    areaMax: string,
    propertyTypes: string,
    amenities: string,
    operationType: string,
    type: string,
    sorting: string,
    freeText: string,
    daysSincePublication: string,
    bankProperty: string,
    furnished: string,
    stratum: string,
    nearbyPoiTypeDistance: string,
}

export class GetNumberOfListingsAjax {
    private readonly eventBus: EventBus

    constructor(
        eventBus: EventBus,
    ) {
        this.eventBus = eventBus;
    }

    execute(params: FiltersParams): void {

        fetch('/wl/api/v1/filter', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(params),
        }).then(async (response) => {
                if (response.ok) {
                    let payload = JSON.parse(await response.text()) as ListingsFilteringResponseEventPayload;
                    payload.buttonId = params.buttonId;
                    this.eventBus.emit(
                        new ListingsFilteringResponseEvent(
                            payload
                        )
                    )
                }
            }
        );
    }

}